import { ImageUpload } from './ImageUpload'

interface ProfessionalProfilePictureSectionProps {
  currentImageUrl: string | undefined
  onImageChange: (file: File | null) => void
  fallbackText: string
  isUploading: boolean
  isSubmitting: boolean
  isActive: boolean
}

export function ProfessionalProfilePictureSection({
  currentImageUrl,
  onImageChange,
  fallbackText,
  isUploading,
  isSubmitting,
  isActive,
}: ProfessionalProfilePictureSectionProps) {
  return (
    <div className="border-b pb-6" data-tour="professional-form-picture">
      <h3 className="text-lg font-semibold mb-4">Foto de Perfil Profesional</h3>
      <ImageUpload
        currentImageUrl={currentImageUrl}
        onImageChange={onImageChange}
        fallbackText={fallbackText}
        disabled={isUploading || isSubmitting || !isActive}
        isUploading={isUploading}
      />
    </div>
  )
}
